var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-dialog",
    {
      attrs: {
        value: _vm.dialogVisible,
        position: _vm.dialogPosition,
        "full-width": _vm.dialogFullWidth,
        persistent: _vm.dialogPersistent,
        square: ""
      },
      on: { hide: _vm.dialogHidden }
    },
    [
      _c(
        "q-card",
        [
          _vm.dialogTitle
            ? _c("dialog-header", {
                attrs: {
                  "dialog-title": _vm.dialogTitle,
                  "dialog-close-button": _vm.dialogCloseButton,
                  "dialog-persistent": _vm.dialogPersistent
                },
                on: { close: _vm.dialogHidden }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "q-card-section",
            [
              _c(_vm.component, {
                tag: "component",
                class: _vm.dialogContentClass,
                style: _vm.dialogContentStyle,
                attrs: { props: _vm.dialogComponentProps }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }